import React from 'react';
import '../App.css';

function PrivacyPolicy() {
    return (
        <div className="App">
            <header className="App-header">
                Privay verklaring
            </header>
            <p>HuurHuisHunter is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze
                privacyverklaring.</p>
            <p>&nbsp;</p>
            <p>Contactgegevens:</p>
            <p>https://www.huurhuishunter.nl</p>
            <p>&nbsp;</p>
            <p><strong>Persoonsgegevens die wij verwerken</strong></p>
            <p>HuurHuisHunter verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze
                zelf aan ons verstrekt.</p>
            <p>&nbsp;</p>
            <p>Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken:</p>
            <p>- Naam</p>
            <p>- E-mailadres</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p><strong>Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</strong></p>
            <p>Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger
                zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of
                een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten
                van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke
                toestemming. Als u er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben
                verzameld over een minderjarige, neem dan contact met ons op via info@huurhuishunter.nl, dan verwijderen
                wij deze informatie.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>HuurHuisHunter verwerkt jouw persoonsgegevens voor de volgende doelen:</p>
            <p>- U de mogelijkheid te bieden een account aan te maken</p>
            <p>- U te kunnen e-mailen indien dit nodig is om onze dienstverlening uit te kunnen voeren</p>
            <p>- U te informeren over wijzigingen van onze diensten en producten</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p><strong>Hoe lang we persoonsgegevens bewaren</strong></p>
            <p>HuurHuisHunter bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren
                waarvoor uw gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende
                (categorie&euml;n) van persoonsgegevens:</p>
            <p>&nbsp;</p>
            <p>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>5 jaar</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p><strong>Delen van persoonsgegevens met derden</strong></p>
            <p>HuurHuisHunter deelt uw persoonsgegevens met verschillende derden als dit noodzakelijk is voor het
                uitvoeren van de overeenkomst en om te voldoen aan een eventuele wettelijke verplichting. Met bedrijven
                die u gegevens verwerken in onze opdracht, sluiten wij een verwerkersovereenkomst om te zorgen voor
                eenzelfde niveau van beveiliging en vertrouwelijkheid van uw gegevens. HuurHuisHunter blijft
                verantwoordelijk voor deze verwerkingen. Daarnaast verstrekt HuurHuisHunter uw persoonsgegevens aan
                andere derden. Dit doen wij alleen met uw nadrukkelijke toestemming.</p>
            <p>&nbsp;</p>
            <p>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>Google Firebase</p>
            <p>&nbsp;</p>
            <p><strong>Cookies, of vergelijkbare technieken, die wij gebruiken</strong></p>
            <p>HuurHuisHunter gebruikt alleen technische en functionele cookies. En analytische cookies die geen inbreuk
                maken op uw privacy. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website
                wordt opgeslagen op uw computer, tablet of smartphone. De cookies die wij gebruiken zijn noodzakelijk
                voor de technische werking van de website en uw gebruiksgemak. Ze zorgen ervoor dat de website naar
                behoren werkt en onthouden bijvoorbeeld uw voorkeursinstellingen. Ook kunnen wij hiermee onze website
                optimaliseren. U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen
                cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen
                van uw browser verwijderen.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p><strong>Gegevens inzien, aanpassen of verwijderen</strong></p>
            <p>U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u
                het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen
                de verwerking van uw persoonsgegevens door HuurHuisHunter en heeft u het recht op
                gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens
                die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te
                sturen.</p>
            <p>&nbsp;</p>
            <p>U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of
                verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen
                naar info@huurhuishunter.nl.</p>
            <p>&nbsp;</p>
            <p>Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw
                identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable
                zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart.
                Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw
                verzoek.</p>
            <p>&nbsp;</p>
            <p>HuurHuisHunter wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de
                nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link:
                https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p><strong>Hoe wij persoonsgegevens beveiligen</strong></p>
            <p>HuurHuisHunter neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik,
                verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u
                de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan
                contact op met onze klantenservice of via info@huurhuishunter.nl</p>
        </div>
    );
}

export default PrivacyPolicy;
